import { Col, Grid } from '@koaly/grid';
import { getColorToken, spacing } from '@koaly/mixins';
import React from 'react';
import { up } from 'styled-breakpoints';
import styled from 'styled-components';
import { Heading } from '../Heading/Heading.js';
import { TitleContent } from '../TitleContent/TitleContent.js';

const StyledContentUsps = styled.section `
  padding: ${({ theme }) => theme.tokens.contentSectionMobilePaddingVertical} 0;
  ${up('s')} {
    padding: ${({ theme }) => theme.tokens.contentSectionSpacingVertical} 0;
  }
`;
const StyledCol = styled(Col) `
  text-align: center;
  color: ${getColorToken('600', 'primary')};
  svg {
    margin-bottom: ${spacing(16)};
  }
`;
const ContentUsps = ({ title, usps, description }) => {
    return (React.createElement(StyledContentUsps, null,
        React.createElement(TitleContent, { align: "center", title: title, description: description, spaceAfter: 28 }),
        React.createElement(Grid, { gutter: 10, gutterRows: { xs: 20, s: 0 } }, usps.map(({ title, illustration: Illustration }, key) => (React.createElement(StyledCol, { width: { xs: 1, s: 1 / 3 }, halign: "center", key: key },
            React.createElement(Illustration, { height: "96px", width: "96px" }),
            React.createElement(Heading, { size: "h4", as: "h3" }, title)))))));
};

export { ContentUsps };
//# sourceMappingURL=ContentUsps.js.map
